const Circle = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="65"
      height="68"
      viewBox="0 0 65 68"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.849121 22.4076V47.8977C0.849121 50.2752 2.09399 52.4722 4.11488 53.6609L25.7806 66.4059C27.8015 67.5947 30.2913 67.5947 32.3122 66.4059L53.9779 53.6609C55.9988 52.4722 57.2437 50.2752 57.2437 47.8977V22.4076C57.2437 20.03 55.9988 17.8331 53.9779 16.6442L32.3122 3.89925C30.2913 2.7105 27.8015 2.7105 25.7806 3.89925L4.11488 16.6442C2.09399 17.8331 0.849121 20.03 0.849121 22.4076Z"
        fill="url(#paint0_linear_5_4740)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.353 1.94696C40.7707 1.94696 44.0852 2.61586 47.2043 3.93517C50.2181 5.20994 52.9251 7.03521 55.2501 9.36024C57.5752 11.6853 59.4004 14.3924 60.6752 17.406C61.9945 20.5252 62.6634 23.8396 62.6634 27.2574C62.6634 30.6751 61.9945 33.9896 60.6752 37.1087C59.4004 40.1225 57.5752 42.8295 55.2501 45.1545C52.9251 47.4796 50.218 49.3048 47.2043 50.5796C44.0852 51.8989 40.7707 52.5678 37.353 52.5678C33.9352 52.5678 30.6208 51.8989 27.5016 50.5796C24.4879 49.3048 21.7809 47.4796 19.4558 45.1545C17.1308 42.8295 15.3055 40.1224 14.0308 37.1087C12.7115 33.9896 12.0426 30.6751 12.0426 27.2574C12.0426 23.8396 12.7115 20.5252 14.0308 17.406C15.3055 14.3923 17.1308 11.6853 19.4558 9.36024C21.7809 7.03521 24.488 5.20994 27.5016 3.93517C30.6208 2.61586 33.9352 1.94696 37.353 1.94696ZM37.353 0C22.2991 0 10.0956 12.2035 10.0956 27.2574C10.0956 42.3112 22.2991 54.5148 37.353 54.5148C52.4068 54.5148 64.6104 42.3112 64.6104 27.2574C64.6104 12.2035 52.4068 0 37.353 0Z"
        fill="black"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1698 35.3406C16.1041 35.3406 14.1718 33.1009 14.0827 32.9954C13.7378 32.5876 13.7912 31.9791 14.2019 31.6366C14.6115 31.2951 15.2218 31.3467 15.5675 31.7517C15.6408 31.8368 17.3407 33.7667 19.8903 33.3526C21.3598 33.1141 23.2993 30.2347 24.5828 28.3293C25.0989 27.5631 25.5446 26.9014 25.9444 26.4043C27.9807 23.8711 30.0599 23.5715 31.4471 23.7666C34.3777 24.1786 36.8324 27.105 37.9653 29.8226C38.8702 31.9938 40.2771 33.253 41.9265 33.3686C43.7971 33.4974 45.7555 32.1685 47.1597 29.807C47.3088 29.5564 47.4707 29.2612 47.6426 28.9487C48.7938 26.853 50.5338 23.6857 53.9254 23.6857C57.7067 23.6857 60.2332 27.8483 60.339 28.0255C60.6124 28.4837 60.4599 29.0754 59.9983 29.347C59.537 29.6186 58.9411 29.467 58.6677 29.0088C58.6632 29.0013 58.1222 28.1088 57.228 27.2401C56.4648 26.4987 55.2724 25.6149 53.9254 25.6149C51.6869 25.6149 50.3899 27.9756 49.3478 29.8726C49.1681 30.1999 48.9981 30.5091 48.8324 30.7878C47.0456 33.7927 44.4132 35.4783 41.7897 35.2929C39.3675 35.1232 37.3718 33.4424 36.1705 30.5605C34.9549 27.6443 32.7373 25.8964 31.1748 25.6765C29.8879 25.4952 28.638 26.1453 27.4625 27.6076C27.1138 28.0414 26.6686 28.7024 26.1973 29.4019C24.5524 31.8439 22.5052 34.8829 20.2035 35.2565C19.8464 35.3144 19.5014 35.3406 19.1698 35.3406Z"
        fill="black"
        fillOpacity="0.4"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5_4740"
          x1="-9.07968"
          y1="7.09965"
          x2="-21.804"
          y2="67.9244"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C8E6C9" />
          <stop offset="1" stopColor="#FFECB3" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Circle;
